"use client";

import { usePathname } from "next/navigation";

export function HtmlLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  // AC 25-08-2026 inclure la page 'accept-cgu' dans les pages scrollables @since v0.5.18
  const scrollable_paths = ['/register', '/accept-cgu'];
  return (
    <html
      lang="fr"
      className={!scrollable_paths.includes(pathname) ? "overflow-y-hidden" : ""}
    >
      {children}
    </html>
  );
}
